(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('NewsViewController', NewsViewController);

    NewsViewController.$inject = ['$scope','$stateParams','$uibModalInstance'];

    function NewsViewController($scope,$stateParams, $uibModalInstance) {
        var vm = this;
        $scope.filename=$stateParams.filename;
        vm.closeView=closeView;

        function closeView()
        {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();
